import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { TODO_DOCUMENT_STATUS } from "../../Todos.constants";
import type { TodoTableTodo } from "../TodoTable";

function getTodoDocumentStatusColumn(
  onChangeTodoStatus: (todoId: number) => void
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Aufgabenstatus",
    accessorKey: "documentProvided",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: TODO_DOCUMENT_STATUS
    },
    filterFn: (row, id, filterValues) => {
      if (filterValues.length === 0) {
        return true;
      }
      return filterValues.includes(row.getValue(id)?.toString() || "");
    },
    Cell: ({ row }) => (
      <Select
        data={TODO_DOCUMENT_STATUS}
        value={row.original.documentProvided?.toString()}
        onChange={() => onChangeTodoStatus(row.original.id)}
      />
    )
  };
}

export { getTodoDocumentStatusColumn };
